import { createTheme as p } from "../../_mixins/use-theme.js";
import C from "../../_styles/common/light.js";
import s from "../../checkbox/styles/light.js";
import c from "../../_internal/scrollbar/styles/light.js";
import h from "../../empty/styles/light.js";
import { changeColor as g } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function f(r) {
  const {
    borderRadiusSmall: e,
    dividerColor: t,
    hoverColor: l,
    pressedColor: i,
    primaryColor: o,
    textColor3: d,
    textColor2: n,
    textColorDisabled: m,
    fontSize: a
  } = r;
  return {
    fontSize: a,
    lineHeight: "1.5",
    nodeHeight: "30px",
    nodeWrapperPadding: "3px 0",
    nodeBorderRadius: e,
    nodeColorHover: l,
    nodeColorPressed: i,
    nodeColorActive: g(o, {
      alpha: 0.1
    }),
    arrowColor: d,
    nodeTextColor: n,
    nodeTextColorDisabled: m,
    loadingColor: o,
    dropMarkColor: o,
    lineColor: t
  };
}
const x = p({
  name: "Tree",
  common: C,
  peers: {
    Checkbox: s,
    Scrollbar: c,
    Empty: h
  },
  self: f
}), y = x;
export {
  y as default,
  f as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/styles/light.js
// module id = 1764
// module chunks = 67